// @flow

import styled from "styled-components";

import { buildTitle } from "../../_atom/Title";
import { buildText } from "../../_atom/Text";

import buildColor from "../../_static/ColorPalette";
import Icon from "../../_static/Icons";
import { defaultTextFont } from "../../_static/Typography";

export const Title = styled(
  buildTitle({
    tag: "h2",
    color: buildColor("grey", "900"),
    uppercase: true,
    fontSize: 12
  })
)`
  line-height: 16px;
  margin-bottom: 8px;
  font-family: ${defaultTextFont};
`;

export const List = styled.ol`
  padding: 0;
  margin: 0;
  list-style: none;

  & > li {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    font-size: 12px;

    &:not(:first-child) {
      margin-top: 8px;
    }
  }
`;

export const Time = styled.time`
  text-transform: uppercase;
  color: ${buildColor("grey", "800")};
  line-height: 1.5;
  white-space: nowrap;
`;

export const Dl = styled.dl`
  width: 100%;
  line-height: 1.5;
  margin: 0 0 4px 4px;
`;

export const Dt = styled.dt`
  display: flex;
  flex-wrap: nowrap;
  border-left: 1px solid ${buildColor("blue", "100")};
  padding-left: 4px;
`;

export const Runner = styled.div`
  width: 16px;
  height: 16px;
  margin: 0 4px;
`;

export const RunnerName = styled(
  buildTitle({
    tag: "h3",
    color: buildColor("grey", "900"),
    uppercase: true,
    fontSize: 14
  })
)`
  line-height: 16px;
  white-space: nowrap;
  margin: 0 4px 0 8px;
`;

export const EmptyStateLabel = buildText({
  fontSize: 12
});

export const ArrowIcon = styled(Icon)`
  margin: 3px 4px 1px;
`;

export const ChangeLblContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
